import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=6b5d7e96&scoped=true"
import script from "./ComponentWrapper.vue?vue&type=script&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&lang=js"
import style0 from "./ComponentWrapper.vue?vue&type=style&index=0&id=6b5d7e96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d7e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5d7e96')) {
      api.createRecord('6b5d7e96', component.options)
    } else {
      api.reload('6b5d7e96', component.options)
    }
    module.hot.accept("./ComponentWrapper.vue?vue&type=template&id=6b5d7e96&scoped=true", function () {
      api.rerender('6b5d7e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/ComponentWrapper.vue"
export default component.exports